import baseApi from "./baseApi"

export default  {
    async getHMSKits() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("assets/hmskits");
        return result.data;
    },
    async getAllIndicatorMinimals() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("assets/indicatorminimals");
        return result.data;
    },
    async addHMSKit(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("assets/hmskit", item);
        return result.data;
    },
    async updateHMSKit(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("assets/hmskit", item);
        return result.data;
    },
    async getBurros() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("assets/burros");
        return result.data;
    },
    async addBurro(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("assets/burro", item);
        return result.data;
    },
    async updateBurro(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("assets/burro", item);
        return result.data;
    }
}